import {Typography} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Grid from '@material-ui/core/Grid';
import React, {useState, useEffect} from 'react';
import {getPerQuestionCorrectStudentAnswers, getQuestionPoints} from './utils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {topicScore} from '../../../api'

export default function QuizSummaryBreakdown(props){
    const {quizDataDict} = props;
    const [topic, setTopic] = useState('')
    useEffect(()=>{
        if (topic !== ""){
            topicScore(quizDataDict.quiz.$oid,quizDataDict._id.$oid, topic)
        }
    },[topic])

    const TableHeader = (props) => (
        <Typography variant="subtitle1">
            <Box fontWeight="fontWeightBold">
                {props.children}
            </Box>
        </Typography>
    );
    const handleSetTopic = (data) => {
        setTopic(data)
    }

    return (
        <ExpansionPanel defaultExpanded={true}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>
                    Quiz Overview
                </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <Grid container spacing={2}>
                    <Grid item xs={5}><TableHeader>Topic</TableHeader></Grid>
                    <Grid item xs={5} className="text-align-right"><TableHeader>Points Earned</TableHeader></Grid>
                    {createTopicBreakdown(quizDataDict, handleSetTopic)}
                </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}

function createTopicBreakdown(quizDataDict, handleSetTopic){

    useEffect(() => {
        
        if (Object.entries(topic).length > 0){
            handleSetTopic(topic)
        }
    },[topic])

    let topic = {};
    quizDataDict.questions.forEach( question => {

        let numCorrectAnswers = getPerQuestionCorrectStudentAnswers(question);
        let totalCorrectAnswers = getQuestionPoints(question);

        if (topic[question.topic]) {
            topic[question.topic]['studentAnswerCorrect'] =
                topic[question.topic]['studentAnswerCorrect'] + numCorrectAnswers;
            topic[question.topic]['totalQuestionPoints'] =
                topic[question.topic]['totalQuestionPoints'] + totalCorrectAnswers;
        }
        else {
            topic[question.topic] = {};
            topic[question.topic]['studentAnswerCorrect'] = numCorrectAnswers;
            topic[question.topic]['totalQuestionPoints'] = totalCorrectAnswers;
        }
    });

    const calcPercent = (num, denom) => (
        (denom !== 0 ? 100 * num / denom : 0).toFixed(0)
    );
    
    
    return (
        Object.entries(topic).map(([key, value]) =>
            <React.Fragment key={`${key}-breakdown`}>
                <Grid item xs={5}><Typography>{key}</Typography></Grid>
                <Grid item xs={5} className="text-align-right">
                    <Typography>
                        {value.studentAnswerCorrect} out of {value.totalQuestionPoints} points
                        ({calcPercent(value.studentAnswerCorrect,value.totalQuestionPoints)}%)
                    </Typography>
                </Grid>
            </React.Fragment>
        )
    );
}